export const load = () => ({
	title: 'Insulate Old Windows Without Replacing',
	showTitle: true,
});
